import _styled from "styled-components";
var _excluded = ["active", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import { ButtonInner } from "../ButtonInner/ButtonInner";
import * as styles from "./TextButton.styles";
export var TextButton = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var active = _ref.active,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledButton, _extends({
    "data-is-active": active,
    ref: forwardedRef
  }, props, {
    $_css: styles.textButton
  }), /*#__PURE__*/React.createElement(ButtonInner, null, children));
});
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  displayName: "TextButton___StyledButton",
  componentId: "sc-xg22d-0"
})(["", ""], function (p) {
  return p.$_css;
});